module.exports = __webpack_public_path__ + "img/icon28.67913eaa.png";